import cx from 'classnames';
import { animationNames } from '../constants';
import { getStageProgressWidth } from '../utils';

const getAnimationNames = (isFirstStage) => {
  return animationNames.slice(0, isFirstStage ? 1 : 2).join();
};

const getLoadingWidth = (isFirstStage, stageNumber, stages) => {
  if (isFirstStage) return '65px';

  return getStageProgressWidth(stages, stageNumber - 1, false);
};

const getStyle = (row, stages, disableProgressAnimations) => {
  const stageNumber = row.status.stage || 1;
  const isFirstStage = stageNumber === 1;
  
  const result = {
    width: getLoadingWidth(isFirstStage, stageNumber, stages),
    backgroundColor: row.isAperiodic || row.isSpontaneous || row.isGrilled ? null : row.statusName.color,
    '--statusScale': getStageProgressWidth(stages, stageNumber),
  };
  
  if (!disableProgressAnimations) {
    result['--animationNames'] = getAnimationNames(isFirstStage);
  }

  return result;
};

export const GoProgress = ({ row, stages, disableProgressAnimations }) => {
  return (
    <div
      className={cx('queue-table__loading', {
        aperiodic: row.isAperiodic,
        spontaneous: row.isSpontaneous,
        grilled: row.isGrilled,
      })}
      style={getStyle(row, stages, disableProgressAnimations)}
    >
      {row.statusName.label}
    </div>
  );
};
